/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Grid, Segment, Form, Input, Button,
  Divider, Dimmer, Loader, Modal, Icon,
  Popup, Radio, Header, Dropdown, Checkbox
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import UpdateLoader from "./UpdateLoader";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";
import sha256 from "js-sha256";
import Timezones from "../utilities/Timezones";

const UtilsInstance = new Utils();

class Configuration extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      tag: "",
      ntpAddr: "",
      isNtpActive: false,
      ntpCheckboxLabel: Strings.TURNED_OFF,
      timezone: "",
      openFile: false,
      isDimmerActive: false,
      isSendGSDMLDimmerActive: false,
      isResetLogDimmerActive: false,
      isResetTrafficDimmerActive: false,
      isNtpDimmerActive: false,
      numOfSuccessfullFilesSent: 0,
      isUpdateDimmerActive: false,
      updateStatus: Constants.NOT_UPDATING,
      ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED,
      isManualDeviceSearchOn: false,
      isManualSearchDimmerActive: false,
      isdeviceSearchDimmerActive: false,
      isRestartSystemModalOpen: false,
      isNtpModalOpen: false,
      isTagConfigDimmerActive: false,
      snmpFastMode: true,
      snmpFastModeDimmerActive: false,
      ethernetText: JSON.parse(sessionStorage.getItem(Constants.WIFI_OR_ETHENET_KEY)) ? Strings.PROFINET_INTERFACE : Strings.ETHERNET,
      wlanText: JSON.parse(sessionStorage.getItem(Constants.WIFI_OR_ETHENET_KEY)) ? Strings.OFFICE_INTERFACE : Strings.WLAN,
      wlanPopupText: JSON.parse(sessionStorage.getItem(Constants.WIFI_OR_ETHENET_KEY)) ? Strings.OFFICE_CONFIG_POPUP : Strings.WLAN_CONFIG_POPUP,
    };

    this.updateLoaderRef = React.createRef();
  }

  showDimmer = () => this.setState({ isDimmerActive: true });
  hideDimmer = () => this.setState({ isDimmerActive: false });

  showGSDMLDimmer = () => this.setState({ isSendGSDMLDimmerActive: true });
  hideGSMLDimmer = () => this.setState({ isSendGSDMLDimmerActive: false });

  showResetLogDimmer = () => this.setState({ isResetLogDimmerActive: true });
  hideResetLogDimmer = () => this.setState({ isResetLogDimmerActive: false });

  showResetTrafficDimmer = () => this.setState({ isResetTrafficDimmerActive: true });
  hideResetTrafficDimmer = () => this.setState({ isResetTrafficDimmerActive: false });

  showUpdateDimmer = () => this.setState({ isUpdateDimmerActive: true });
  hideUpdateDimmer = () => this.setState({ isUpdateDimmerActive: false });

  showManualSearchDimmer = () => this.setState({ isManualSearchDimmerActive: true });
  hideManualSearchDimmer = () => this.setState({ isManualSearchDimmerActive: false });

  showDeviceSearchDimmer = () => this.setState({ isdeviceSearchDimmerActive: true });
  hideDeviceSearchDimmer = () => this.setState({ isdeviceSearchDimmerActive: false });

  showRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: true });
  hideRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: false });

  showTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: true });
  hideTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: false });

  showNtpDimmer = () => this.setState({ isNtpDimmerActive: true });
  hideNtpDimmer = () => this.setState({ isNtpDimmerActive: false });

  showSnmpModeDimmer = () => this.setState({ snmpFastModeDimmerActive: true });
  hideSnmpModeDimmer = () => this.setState({ snmpFastModeDimmerActive: false });

  showNtpModal = () => this.setState({ isNtpModalOpen: true });
  hideNtpModal = () => this.setState({ isNtpModalOpen: false });

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.tag)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "isManualDeviceSearchOn", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "ntp", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "snmpFastMode", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      tag: resolvedPromisses[0],
      ntpAddr: resolvedPromisses[2].ntpIp,
      isNtpActive: resolvedPromisses[2].ntp,
      timezone: resolvedPromisses[2].timezone,
      ntpCheckboxLabel: resolvedPromisses[2].ntp ? Strings.TURNED_ON : Strings.TURNED_OFF,
      snmpFastMode: resolvedPromisses[3].snmpFastMode,
    }, () => {
      this.setRadioState(resolvedPromisses[1].isOn);
    });
  }

  //Sends a .gpg file to the server to update the monitor software
  sendFile = () => {
    let input = document.querySelector("input[type=\"file\"]");
    // If the file exists and doesn't contain ".gpg" in its name
    if (input.files[0] !== undefined && input.files[0] !== null) {
      if (input.files[0].name.indexOf(Constants.GPG_FILE_EXTENSION) === -1) {
        alert(Strings.GPG_ALERT_MESSAGE);
      }
      else {
        let data = new FormData();
        let reader = new FileReader();
        let sha256Checksum = "";

        reader.onload = (event) => {
          sha256Checksum = sha256(event.target.result);

          data.append("updateFile", input.files[0]);
          data.append("checkSum", sha256Checksum);

          this.showDimmer();

          fetch(Constants.REQUEST_IP_ADDRESS + "sendFile_POST", {
            method: "POST",
            body: data
          })
            .then(UtilsInstance.checkStatus)
            .then(() => {
              this.handleUpdateCycles(Constants.FILE_UPDATE_TYPE);
            })
            .catch((error) => {
              if (error.response.status === 415) {
                alert(Strings.SEND_FILE_FAILURE + "\n" + Strings.REASON_DP + Strings.SEND_FILE_WRONG_FILENAME);
              }
              else if (error.response.status === 417) {
                alert(Strings.SEND_FILE_FAILURE + "\n" + Strings.REASON_DP + Strings.SEND_FILE_CORRUPTED_FILE);
              }
              else {
                alert(Strings.SEND_FILE_FAILURE + "\n" + Strings.REASON_DP + error);
              }
            })
            .finally(this.hideDimmer);
        };

        reader.onerror = (event) => {
          reader.abort();
          alert(Strings.SEND_FILE_FAILURE + "\n" + Strings.REASON_DP + event);
        };

        reader.readAsArrayBuffer(input.files[0]);
      }
    }
    else {
      alert(Strings.SELECT_FILE);
    }
  }

  sendGSDMLFiles = async () => {
    let input = document.getElementById("send-gsdml-files-input");
    let notSentFilenames = [];

    if (input.files.length > 0) {

      document.getElementById("total-num-of-files").innerText = input.files.length;

      this.showGSDMLDimmer();

      for (let i = 0; i < input.files.length; i++) {
        let data = new FormData();
        data.append(input.files[i].name, input.files[i]);

        // Send the gsdml files one by one, wait for the fetch to return before starting another one
        await fetch(Constants.REQUEST_IP_ADDRESS + "sendGsdml_POST", {
          method: "POST",
          body: data
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            // If the file was sent successfully, increment the number of files sent and show it on the loading dimmer
            this.setState({ numOfSuccessfullFilesSent: this.state.numOfSuccessfullFilesSent + 1 }, () => {
              document.getElementById("num-of-successful-files-sent").innerText = this.state.numOfSuccessfullFilesSent;
            });
          })
          .catch(() => {
            // If there was a problem while sending the file, add the file name to an array
            // so it can be shown to the user later
            notSentFilenames.push(input.files[i].name);
          });

        await new Promise(resolve => setTimeout(resolve, 500));
      }

      // If all the files have been sent, alert the user
      if (notSentFilenames.length === 0) {
        setTimeout(() => {
          alert(Strings.SEND_FILES_SUCCESS);
          this.hideGSMLDimmer();
          this.setState({ numOfSuccessfullFilesSent: 0 }, () => {
            document.getElementById("num-of-successful-files-sent").innerText = 0;
          });
        }, 500);
      }
      // If at least one file was not sent, alert the user, and show a list of all of the files
      // that were not sent
      else {
        let notSentFilenamesList = "";

        for (let i = 0; i < notSentFilenames.length; i++) {
          notSentFilenamesList = notSentFilenamesList.concat("\n• " + notSentFilenames[i]);
        }

        alert(Strings.THE_FOLLOWING_FILES_COULD_NOT_BE_SENT + notSentFilenamesList);
        this.hideGSMLDimmer();
        this.setState({ numOfSuccessfullFilesSent: 0 }, () => {
          document.getElementById("num-of-successful-files-sent").innerText = 0;
        });
      }
    }
    else {
      alert(Strings.SELECT_AT_LEAST_ONE_FILE);
    }
  }

  removeGSDML = () => {
    this.props.history.push({
      pathname: "/edit-gsdml"
    });
  }

  cleanLog = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetLogDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "resetLog_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.CLEAN_LOG_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.CLEAN_LOG_FAILURE + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideResetLogDimmer);
  }

  handleNTPAddressChange = (e, { value }) => {
    this.setState({ ntpAddr: value });
  }

  toggleNtpActive = () => {
    this.setState({
      ntpCheckboxLabel: !this.state.isNtpActive ? Strings.TURNED_ON : Strings.TURNED_OFF,
      isNtpActive: !this.state.isNtpActive
    });
  }

  logOut = () => {
    sessionStorage.removeItem("auth");
    this.props.history.push({ pathname: "/login-handler" });
  }

  generateReport = () => {
    this.props.history.push({ pathname: "/report" });
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  changeLoginInfo = () => {
    this.props.history.push({ pathname: "/change-login" });
  }

  resetTraffic = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetTrafficDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "resetTraffic_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.RESET_TRAFFIC_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.RESET_TRAFFIC_FAILURE + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideResetTrafficDimmer);
  }

  editBlacklist = () => {
    this.props.history.push({
      pathname: "/blacklist"
    });
  }

  openSweepPage = () => {
    this.props.history.push({
      pathname: "/sweep"
    });
  }

  handleUpdateCycles = (type) => {
    this.showUpdateDimmer();
    let intervalID = -1;

    if (type === Constants.FILE_UPDATE_TYPE) {
      this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, "");
      intervalID = setInterval(this.handleUpdateFilesStatus, 2000);
    }
    else if (type === Constants.NTP_UPDATE_TYPE) {
      this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, "");
      intervalID = setInterval(this.handleUpdateNtpStatus, 2000);
    }
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleUpdateFilesStatus = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.UPDATE_FILES_FOUND) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.UPDATING_MONITOR_FILES);
          });
        }
        else if (this.state.updateStatus === Constants.UPDATE_FILES_FOUND && data.update === Constants.FINISHED_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.MONITOR_FILES_UPDATED_SUCCESSFULLY);
          });
        }
        else if (this.state.updateStatus === Constants.FINISHED_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.RESTARTING_MONITOR_WAIT);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, "");
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.UPDATE_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.UPDATE_ERROR_STRING + error);
      });
  }

  handleUpdateNtpStatus = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, Strings.RESTARTING_MONITOR_WAIT);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, "");
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.MONITOR_RESTART_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.MONITOR_RESTART_FAILURE + error);
      });

  }

  setRadioState = (isOn) => {
    // if isOn is null, consider it as being false, overwritingits value in the database to false
    // and also overwriting the number of searches on the database to 0
    if (isOn === null) {
      let manualSearch = {
        isOn: false
      };

      let data = JSON.stringify(manualSearch);

      fetch(Constants.REQUEST_IP_ADDRESS + "manualDeviceSearch_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data,
        mode: "cors"
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.setState({ isManualDeviceSearchOn: false }, () => {

            this.setSearchButtonState(this.state.isManualDeviceSearchOn);

            // Now overwrite the number of arp scans to 0
            let arpScanQuantity = {
              quantity: 0
            };

            let data = JSON.stringify(arpScanQuantity);

            fetch(Constants.REQUEST_IP_ADDRESS + "arpScanQuantity_POST", {
              method: "POST",
              headers: {
                "Content-Type": "application/json;charset=UTF-8"
              },
              body: data,
              mode: "cors"
            })
              .then(UtilsInstance.checkStatus)
              .catch((error) => {
                alert(Strings.ERROR_FETCHING_SEARCH_STATE + "\n" + Strings.REASON_DP + error);
              });

          });
        })
        .catch((error) => {
          alert(Strings.ERROR_FETCHING_SEARCH_STATE + "\n" + Strings.REASON_DP + error);
        });
    }
    else {
      this.setState({ isManualDeviceSearchOn: isOn }, () => {
        this.setSearchButtonState(this.state.isManualDeviceSearchOn);
      });
    }
  }

  setSearchButtonState = (isManualDeviceSearchOn) => {
    let searchButton = document.getElementById("search-devices-button");

    if (isManualDeviceSearchOn) {
      searchButton.disabled = false;
    }
    else {
      searchButton.disabled = true;
    }
  }

  searchDevices = () => {
    let arpScanQuantity = {
      quantity: 5
    };

    let data = JSON.stringify(arpScanQuantity);

    this.showDeviceSearchDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "arpScanQuantity_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.DEVICE_SEARCH_INIT_SUCCESS);
        this.hideDeviceSearchDimmer();
      })
      .catch((error) => {
        alert(Strings.DEVICE_SEARCH_INIT_FAILURE + "\n" + Strings.REASON_DP + error);
        this.hideDeviceSearchDimmer();
      });
  }

  handleRadioChange = () => {
    this.setState({ isManualDeviceSearchOn: !this.state.isManualDeviceSearchOn }, () => {
      this.showManualSearchDimmer();

      let manualSearch = {
        isOn: this.state.isManualDeviceSearchOn
      };

      let data = JSON.stringify(manualSearch);

      fetch(Constants.REQUEST_IP_ADDRESS + "manualDeviceSearch_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data,
        mode: "cors"
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.setSearchButtonState(this.state.isManualDeviceSearchOn);
          this.hideManualSearchDimmer();
        })
        .catch((error) => {
          alert(Strings.ERROR_ALTERING_SEARCH_STATE + "\n" + Strings.REASON_DP + error);
          this.setState({ isManualDeviceSearchOn: !this.state.isManualDeviceSearchOn }, () => {
            this.setSearchButtonState(this.state.isManualDeviceSearchOn);
            this.hideManualSearchDimmer();
          });
        });
    });
  }

  handleRestartSystemModalPositiveClick = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "restartSystem_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.RESTART_SYSTEM_SUCCESS);
      })
      .catch(function (error) {
        alert(Strings.RESTART_SYSTEM_FAILURE + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideRestartSystemModal);
  }

  handleTagChange = (e, { value }) => {
    this.setState({ tag: value });
  }

  sendTag = () => {
    this.showTagConfigDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "tag_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ tag: this.state.tag })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TAG_WAS_CHANGED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TAG_CHANGE_FAILURE + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideTagConfigDimmer);
  }

  openEthernetPage = () => {
    this.props.history.push({ pathname: "/ethernet-config" });
  }

  openWLANPage = () => {
    if (JSON.parse(sessionStorage.getItem(Constants.WIFI_OR_ETHENET_KEY))) {
      this.props.history.push({ pathname: "/office-ethernet-config" });
    }
    else {
      this.props.history.push({ pathname: "/wlan-config" });
    }
  }

  configureTsExpert = () => {
    this.props.history.push({ pathname: "/ts-expert-config" });
  }

  handleTurnNtpServerOnModalPositiveClick = () => {
    this.hideNtpModal();
    this.updateNtpServer();
  }

  saveNtpServerInfo = () => {
    let isIpValid = UtilsInstance.validateIPAddress(this.state.ntpAddr);
    let isIPLoopback = UtilsInstance.isIPLoopback(this.state.ntpAddr);

    // Verify the network information provided. Only send it if it passes the validation
    if (!isIpValid || isIPLoopback || this.state.timezone.length === 0) {
      let invalidInformationString = Strings.VERIFY_THE_FOLLOWING_INFO;

      // If the IP is not valid or if it is the loopback IP (127.0.0.1)
      if (!isIpValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_IP);
      }
      else if (isIPLoopback) {
        invalidInformationString = invalidInformationString.concat(Strings.LOOPBACK_IP_NTP);
      }

      if (this.state.timezone.length === 0) {
        invalidInformationString = invalidInformationString.concat(Strings.SELECT_TIMEZONE);
      }

      alert(invalidInformationString);
    }
    else {
      // If the user is turning the ntp server off there is no need to ask
      // for permission to restart because the system will not restart
      if (this.state.isNtpActive === false) {
        this.updateNtpServer();
      }
      // If the user is turning the ntp server on we will need ask for permission
      // to restart the system
      else {
        this.showNtpModal();
      }
    }
  }

  updateNtpServer = () => {
    let data = JSON.stringify({
      ntp: this.state.isNtpActive,
      ntpIp: this.state.ntpAddr,
      timezone: this.state.timezone
    });

    if (this.state.isNtpActive === false) {
      this.showNtpDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "ntp_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.updateNtpServerFirstStep();
        })
        .catch((error) => {
          console.log(error);
          alert(Strings.NTP_INFO_TURNED_OFF_FAILURE + "\nMotivo: " + Strings.NTP_INFO_FAILURE);
          this.toggleNtpActive();
        })
        .finally(this.hideNtpDimmer);
    }
    else {
      this.showNtpDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "ntp_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.updateNtpServerFirstStep();
        })
        .catch((error) => {
          this.toggleNtpActive();
          console.log(error);
          alert(Strings.NTP_INFO_TURNED_ON_FAILURE + "\n" + Strings.REASON_DP + Strings.NTP_INFO_FAILURE);
        })
        .finally(this.hideNtpDimmer);
    }
  }

  updateNtpServerFirstStep = () => {
    let intervalID = -1;
    this.showUpdateDimmer();
    this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSING_NTP_INIT, "");
    intervalID = setInterval(this.handleUpdateNtpFirstStep, 2000);
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleUpdateNtpFirstStep = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "ntpUpdate", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.ntpUpdate);
        console.log("Data update Status: ", data.ntpUpdate);

        if (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED && data.ntpUpdate === Constants.NTP_UPDATE_START) {
          this.setState({ ntpUpdate: data.ntpUpdate }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSING_NTP_INFO, "");
          });
        }
        else if (
          (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED || this.state.ntpUpdate === Constants.NTP_UPDATE_START)
          && data.ntpUpdate === Constants.NTP_UPDATE_SUCCESS
        ) {
          this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSED_NTP_INFO, "");
            clearInterval(this.state.intervalID);
            this.handleUpdateCycles(Constants.NTP_UPDATE_TYPE);
          });
        }
        else if (
          (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED || this.state.ntpUpdate === Constants.NTP_UPDATE_START)
          && data.ntpUpdate === Constants.NTP_UPDATE_FAIL
        ) {
          this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED }, () => {
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.PROCESSING_NTP_ERROR);
            this.toggleNtpActive();
          });
        }
      })
      .catch(() => {
        this.hideUpdateDimmer();
        clearInterval(this.state.intervalID);
        this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED });
        alert(Strings.PROCESSING_NTP_ERROR);
        this.toggleNtpActive();
      });
  }

  onTimezoneDropdownChange = (e, { value }) => this.setState({ timezone: value })

  handleSnmpModeChange = () => {
    this.setState({ snmpFastMode: !this.state.snmpFastMode });
  }

  sendSnmpMode = () => {
    this.showSnmpModeDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "snmpFastMode_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ snmpFastMode: this.state.snmpFastMode })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.SNMP_MODE_WAS_CHANGED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.SNMP_MODE_CHANGE_FAILURE + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideSnmpModeDimmer);
  }

  alterTags = () => {
    this.props.history.push({ pathname: "/tags" });
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
    this.setState({ updateStatus: Constants.NOT_UPDATING });
  }

  render() {
    const isDimmerActive = this.state.isDimmerActive;
    const isSendGSDMLDimmerActive = this.state.isSendGSDMLDimmerActive;
    const isResetLogDimmerActive = this.state.isResetLogDimmerActive;
    const isResetTrafficDimmerActive = this.state.isResetTrafficDimmerActive;
    const isUpdateDimmerActive = this.state.isUpdateDimmerActive;
    const isManualSearchDimmerActive = this.state.isManualSearchDimmerActive;
    const isdeviceSearchDimmerActive = this.state.isdeviceSearchDimmerActive;
    const isTagConfigDimmerActive = this.state.isTagConfigDimmerActive;
    const isNtpDimmerActive = this.state.isNtpDimmerActive;
    const snmpFastModeDimmerActive = this.state.snmpFastModeDimmerActive;

    return (
      <div className="ts-config-page" style={configPageStyle}>

        <div className="ts-config-actions-row">
          <div className="ts-config-actions">
            <Button
              icon
              className="ts-config-danger-button"
              color="red"
              onClick={this.showRestartSystemModal}>
              <Icon name='power off' />
              {Strings.RESTART_SYSTEM}
            </Button>
            <Button className="ts-config-logout-button" color="grey" onClick={this.logOut}>Logout</Button>
          </div>
        </div>

        <Grid className="ts-config-grid ts-config-board" centered columns={2} doubling>
          <Grid.Column className="ts-config-column">

            <Segment>
              <Divider horizontal style={zeroMarginStyle}>{Strings.TAG_CONFIG}</Divider>
              <Form style={formStyle} onSubmit={this.sendTag}>

                <Form.Field>
                  <Input
                    placeholder={Strings.TEST_NETWORK}
                    value={this.state.tag}
                    onChange={this.handleTagChange} />
                </Form.Field>

                <Button color="teal" type="submit" >{Strings.SETUP}</Button>
              </Form>
              <Dimmer active={isTagConfigDimmerActive} >
                <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Segment textAlign="center">
              <Divider horizontal style={zeroMarginStyle}>{Strings.TAGS}</Divider>
              <Button color="teal" onClick={this.alterTags}>{Strings.ADD_ALTER_TAGS}</Button>
            </Segment>

            <Segment className="ts-config-ntp-segment" textAlign="center">
              <Divider horizontal style={zeroMarginStyle}>{Strings.NTP_SERVER}</Divider>

              <Form onSubmit={this.saveNtpServerInfo}>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: "1vh" }}>
                  <div style={{ flexGrow: 2 }}>
                    <Form.Field>
                      <label>IP</label>
                      <Input
                        fluid
                        placeholder="192.168.0.2"
                        value={this.state.ntpAddr}
                        onChange={this.handleNTPAddressChange} />
                    </Form.Field>

                    <Form.Field>
                      <label>Timezone</label>
                      <Dropdown
                        className="ts-ntp-timezone-dropdown"
                        fluid
                        placeholder="Timezone"
                        search
                        selection
                        scrolling
                        options={Timezones.zones}
                        value={this.state.timezone}
                        onChange={this.onTimezoneDropdownChange} />
                    </Form.Field>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <Form.Field>
                      <Checkbox
                        toggle
                        onClick={this.toggleNtpActive}
                        checked={this.state.isNtpActive}
                        label={this.state.ntpCheckboxLabel} />
                    </Form.Field>
                  </div>
                </div>

                <Button color="teal" type="submit">{Strings.SETUP}</Button>
              </Form>

              <Dimmer active={isNtpDimmerActive} >
                <Loader>{Strings.SEND_NTP_CONFIG_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Grid columns={2} doubling>

              <Grid.Column style={paddingRightStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>
                    {this.state.ethernetText}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        {Strings.ETHERNET_CONFIG_POPUP}
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button
                    content={Strings.SETUP}
                    color="teal"
                    onClick={this.openEthernetPage} />
                </Segment>
              </Grid.Column>

              <Grid.Column style={paddingLeftStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>
                    {this.state.wlanText}
                    <Popup position='top center' hoverable pinned wide="very"
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        {this.state.wlanPopupText}
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button
                    content={Strings.SETUP}
                    color="teal"
                    onClick={this.openWLANPage} />
                </Segment>
              </Grid.Column>
            </Grid>

            <Grid columns={2} doubling style={zeroMarginStyle}>

              <Grid.Column style={paddingRightStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>
                    Blacklist
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        {Strings.BLACKLIST_CONFIG_POPUP}
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button color="teal" onClick={this.editBlacklist}>{Strings.EDIT}</Button>
                </Segment>
              </Grid.Column>

              <Grid.Column style={paddingLeftStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>
                    {Strings.SWEEP}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        {Strings.SWEEP_POPUP_MSG}
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button id="sweep-page-button" color="teal" onClick={this.openSweepPage}>{Strings.SETUP}</Button>
                </Segment>
              </Grid.Column>

            </Grid>

            <Grid columns={2} doubling>

              <Grid.Column style={paddingRightStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>
                    {Strings.DEVICE_SEARCH}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        {Strings.DEVICE_SEARCH_QUESTION_ICON_INFO}
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Grid columns={2} doubling textAlign="center" verticalAlign="middle">
                    <Grid.Column>

                      <Radio
                        label={Strings.UNIQUE}
                        name="deviceSearchRadioGroup"
                        checked={this.state.isManualDeviceSearchOn}
                        onChange={this.handleRadioChange} />
                      <br />
                      <Radio
                        label={Strings.CONTINUOUS}
                        name="deviceSearchRadioGroup"
                        checked={!this.state.isManualDeviceSearchOn}
                        onChange={this.handleRadioChange} />

                    </Grid.Column>

                    <Grid.Column>
                      <Button id="search-devices-button" color="teal" onClick={this.searchDevices}>{Strings.SEARCH}</Button>
                    </Grid.Column>
                  </Grid>

                  <Dimmer active={isManualSearchDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>

                  <Dimmer active={isdeviceSearchDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>

                </Segment>
              </Grid.Column>

              <Grid.Column style={paddingLeftStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>
                    {Strings.TS_EXPERT}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        {Strings.TS_EXPERT_CONFIG_POPUP}
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button color="teal" onClick={this.configureTsExpert}>{Strings.SETUP}</Button>
                </Segment>
              </Grid.Column>

            </Grid>

          </Grid.Column>

          <Grid.Column className="ts-config-column">

            <Segment style={updateSegmentStyle}>
              <Divider horizontal style={zeroMarginStyle}>{Strings.SOFTWARE_UPDATE}</Divider>
              <p>{Strings.CURRENT_VERSION}<b>{Constants.TS_MONITOR_VERSION}</b></p>
              <Form style={formStyle} onSubmit={this.sendFile}>
                <Form.Input type="file" accept=".gpg"></Form.Input>
                <Button color="teal" type="submit" >{Strings.UPDATE}</Button>
              </Form>
              <Dimmer active={isDimmerActive} >
                <Loader>{Strings.SEND_FILE_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Segment>
              <Divider horizontal style={zeroMarginStyle}>
                {Strings.GSDML_FILES}
                <Popup position='top center' hoverable pinned wide="very"
                  trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                  <Popup.Content>
                    {Strings.GSDML_QUESTION_ICON_INFO}
                  </Popup.Content>
                </Popup>
              </Divider>
              <Form>
                <Form.Input id="send-gsdml-files-input" type="file" accept=".xml" multiple></Form.Input>
                <div style={gsdmlFormStyle}>
                  <div style={gsdmlLeftButtonStyle}>
                    <Button color="teal" onClick={this.sendGSDMLFiles}>{Strings.SEND}</Button>
                  </div>
                  <div style={gsdmlRightButtonStyle}>
                    <Button color="teal" onClick={this.removeGSDML}>{Strings.MANAGE}</Button>
                  </div>
                </div>
              </Form>
              <Dimmer active={isSendGSDMLDimmerActive} >
                <Loader><p>{Strings.SEND_FILES_WAITING}</p>
                  <p><span id="num-of-successful-files-sent">0</span> / <span id="total-num-of-files"></span></p></Loader>
              </Dimmer>
            </Segment>

            <Grid columns={2} doubling>
              <Grid.Column style={paddingRightStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>Log</Divider>
                  <Button color="teal" onClick={this.cleanLog}>{Strings.CLEAR}</Button>
                  <Dimmer active={isResetLogDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>
                </Segment>
              </Grid.Column>

              <Grid.Column style={paddingLeftStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>{Strings.TRAFFIC_ERROR_INCREMENT}</Divider>
                  <Button color="teal" onClick={this.resetTraffic}>{Strings.CLEAR}</Button>
                  <Dimmer active={isResetTrafficDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>
                </Segment>
              </Grid.Column>
            </Grid>

            <Grid columns={2} doubling>

              <Grid.Column style={paddingRightStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>{Strings.REPORT}</Divider>
                  <Button color="teal" onClick={this.generateReport}>{Strings.GENERATE_REPORT}</Button>
                </Segment>
              </Grid.Column>


              <Grid.Column style={paddingLeftStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>{Strings.ALTER_LOGIN}</Divider>
                  <Button color="teal" onClick={this.changeLoginInfo}>{Strings.ALTER}</Button>
                </Segment>
              </Grid.Column>

            </Grid>

            <Grid columns={2} doubling>

              <Grid.Column style={paddingRightStyle}>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal style={zeroMarginStyle}>
                    {Strings.SNMP_MODE}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        {Strings.SNMP_MODE_QUESTION_ICON_INFO_1}<br />
                        {Strings.SNMP_MODE_QUESTION_ICON_INFO_2}
                      </Popup.Content>
                    </Popup>
                  </Divider>

                  <Grid columns={2} doubling textAlign="center" verticalAlign="middle">
                    <Grid.Column>
                      <Radio
                        label={Strings.SNMP_MODE_FAST}
                        checked={this.state.snmpFastMode}
                        onChange={this.handleSnmpModeChange} />
                      <br />
                      <Radio
                        label={Strings.SNMP_MODE_SLOW}
                        checked={!this.state.snmpFastMode}
                        onChange={this.handleSnmpModeChange} />
                    </Grid.Column>

                    <Grid.Column>
                      <Button color="teal" onClick={this.sendSnmpMode}>{Strings.SETUP}</Button>
                    </Grid.Column>
                  </Grid>

                  <Dimmer active={snmpFastModeDimmerActive} >
                    <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
                  </Dimmer>

                </Segment>
              </Grid.Column>

              <Grid.Column style={paddingLeftStyle}>
              </Grid.Column>

            </Grid>
          </Grid.Column>
        </Grid>

        <Modal basic size='small' open={this.state.isNtpModalOpen}>
          <Header icon='power' content={Strings.TURN_NTP_SERVER_ON} />
          <Modal.Content>
            <p>{Strings.TURN_NTP_SERVER_ON_QUESTION}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={this.hideNtpModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.handleTurnNtpServerOnModalPositiveClick}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic size='small' open={this.state.isRestartSystemModalOpen}>
          <Header icon='history' content={Strings.RESTART_SYSTEM} />
          <Modal.Content>
            <p>{Strings.CONFIRM_RESTART_SYSTEM}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={this.hideRestartSystemModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.handleRestartSystemModalPositiveClick}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <Dimmer page active={isUpdateDimmerActive}>
          <UpdateLoader ref={this.updateLoaderRef} />
        </Dimmer>
      </div >
    );
  }
}

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const updateSegmentStyle = {
  textAlign: "center"
};

const zeroMarginStyle = {
  marginTop: 0
};

const paddingRightStyle = {
  paddingRight: 5
};

const paddingLeftStyle = {
  paddingLeft: 5
};


const configPageStyle = {
  textAlign: "center"
};

const gsdmlFormStyle = {
  display: "flex"
};

const gsdmlLeftButtonStyle = {
  flexGrow: "1",
  textAlign: "center"
};

const gsdmlRightButtonStyle = {
  flexGrow: "1",
  textAlign: "center"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default withRouter(Configuration);
